import { appGetState } from 'legacy/lut/store'

import { Nullable } from 'clickNgo/models/utils'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'

export interface IFetchQBRDocumentPartners {
  entryId: number | null
  partnerIds?: Nullable<string>
  fYear?: Nullable<number>
  settings?: Nullable<string>
  rtm?: Nullable<string>
}

export const fetchQBRDocumentPartners = async ({
  entryId,
  partnerIds,
  fYear,
  settings,
  rtm,
}: IFetchQBRDocumentPartners): Promise<IQBRPartner[]> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPQBRDocumentPartners/call`)

  const payload = {
    'p.EntryId': entryId,
    'p.PartnerIDs': partnerIds,
    'p.FYear': fYear,
    'p.Settings': settings ? settings : null,
    'p.RTM': rtm,
  }

  const {
    app: { ownerId },
  } = appGetState()

  const [accessToken] = getTokens(ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })

    return response.Data
  } catch (e) {
    return []
  }
}
